/*
Created-by: XtroEdge AI
Updated-by: XtroEdge AI
Last modified: 2026-11-04T18:05:00+05:00
Intent: One web-link validator for every form. Moved out of branding so the Link level uses the same rule; ^https?:// alone let "https://.com" and "https://example..com" through.
*/
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/** Every dot-separated label starts and ends with a letter or digit, and the last one is a 2+ letter TLD. */
const HOST_NAME = /^([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/;

/** Whether `value` is a full http(s) link with a real host name: no "https://.com", no "example..com". */
export function isValidWebUrl(value: any): boolean {
  const text = String(value ?? '').trim();
  if (!text || /\s/.test(text)) return false;
  let url: URL;
  try {
    url = new URL(text);
  } catch {
    return false;
  }
  return /^https?:$/.test(url.protocol) && HOST_NAME.test(url.hostname.toLowerCase());
}

/**
 * An optional web link: empty passes; otherwise a full http(s) URL with a real host name.
 * With `hosts`, the link must also be on one of those sites.
 */
export function webUrlValidator(hosts?: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = String(control.value ?? '').trim();
    if (!value) return null;
    if (!isValidWebUrl(value)) return { url: true };
    const host = new URL(value).hostname.toLowerCase();
    if (hosts && !hosts.some((h) => host === h || host.endsWith('.' + h))) {
      return { urlSite: { site: hosts[0] } };
    }
    return null;
  };
}
